import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import Experience from './Experience.jsx'
import LoadingScreen from './LoadingScreen.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        <LoadingScreen />
        <Canvas
            camera={{
                fov: 35,
                near: 0.1,
                far: 2000,
                position: [ - 1, 2, 3 ],
            }}
        >
            <Suspense>
                <Experience />
            </Suspense>
        </Canvas>
    </>
)
